import { computed } from 'vue'
import { useFetchCMS } from 'src/composables/useFetchCMS'
import { useStore } from 'vuex'
import * as Common from 'src/utils/constants/common'
import DOMPurify from 'dompurify';
import { MdButton } from '@antiqua-dls/vue-components';

export default{
  components:{
    MdButton
  },
  setup(){
    const sanitizeUrl = (url) => {
      return DOMPurify.sanitize(url)
    }
    const store = useStore()
    const { data, loading, error, cmsConfig, getCmsData } = useFetchCMS()
    const getCompleteURL = (url, dimension) => `${cmsConfig.domainURL}cdn-cgi/image/width=${dimension.width},height=${dimension.height},fit=contain,format=auto${url}`
    const content = computed(() => data?.value?.data?.resource_contents[1])
    const ufda2Status = computed(() => store.getters['dashboard/getUfda2Status'])
    const bgImage = computed(() => getCompleteURL(content.value.image.image, Common.CMS_IMAGE_DIMENSIONS.type_trend_image))
    const anchorTarget = computed(() => ufda2Status.value ? '_blank' : null)
    const learnMoreDataQaId = computed(() => ufda2Status.value ? 'trends-tips-learn-more-enable' : 'trends-tips-learn-more-disabled')
    const contentUrl = (url) => ufda2Status.value ? sanitizeUrl(url) : null

    getCmsData(cmsConfig.merchendisingTips)
    return{
      data,
      loading,
      error,
      getCompleteURL,
      content,
      bgImage,
      ufda2Status,
      contentUrl,
      anchorTarget,
      learnMoreDataQaId,
      sanitizeUrl
    }
  }

}
